export const READ_PROMPT_TOOLS_TOOL_NAME = "read_prompt_tools";
export const WRITE_PROMPT_TOOLS_TOOL_NAME = "write_prompt_tools";
